<template>
  <div>
    <ModalIdle v-if="isIdle" />
    <barra-navegacao />
    <v-content>
      <div class="container">
        <router-view />
      </div>
    </v-content>
  </div>
</template>

<script>
export default {
  name: "Home",

  data: () => ({
    expandOnHover: false,
  }),
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  components: {
    BarraNavegacao: () => import("../components/Menu/BarraNavegacao"),
    ModalIdle: () => import("@/components/ModalIdle"),
  },
};
</script>
